export const SLIDER_NORM_WIDTH = 120;
export const SLIDER_SMALL_WIDTH = 80;
